import React, { useEffect, useState } from 'react';
import QATicketApiService from '../../ApiServices/QATicketApiServices/QATicketApiService';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from "../Auth/AuthContext";
import QATicketReplyModal from "../QATicket/QATicketReply";

const QATicketTable = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [data, setData] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [isRepy, setIsRepy] = useState(false);
    const [currentTicketReplies, setReplies] = useState([]);
    const [isView, setIsView] = useState(false);
    const [ticketId, setTicketId] = useState(null);

    const handleView = (index) => {
        setIsView(true);
        setCurrentItem(data[index]);
    };

    const handleReply = async (id) => {
        var replies = await QATicketApiService.GetReplies(id);
        setReplies(replies?.data ?? []);
        setIsRepy(true);
        setTicketId(id);
        setIsView(false)
    };

    const handleResolveTicket = async (id) => {
        var data = {
            ticketId: id,
            status: "Resolved"
        }
        await QATicketApiService.ResolveTicket(data);
        setIsView(false)
    };

    const [currentItem, setCurrentItem] = useState(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);
    const { authState } = useAuth(); // Get authState from AuthContext
    const role = authState.roles;
    const admin = role === "Admin";


    const fetchData = async () => {
        try {
            const qaTicketData = await QATicketApiService.Get();

            const qaTicketDataArray = Array.isArray(qaTicketData.data) ? qaTicketData.data : [qaTicketData.data];

            const qaTicketDataMap = qaTicketDataArray.map((item) => ({
                Title: item.Title || item.title,
                Description: item.Description || item.description,
                Apporweb: item.Apporweb || item.apporweb,
                Status: item.Status || item.status,
                CreatedOn: new Date(item.CreatedOn || item.createdOn).toISOString().split('T')[0],//item.createdOn || item.createdDate,
                Id: item.Id || item.id
            }));

            console.log("Combined Data:", qaTicketDataMap); // Check the structure here
            setData(qaTicketDataMap);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchPublisherData = async (userId) => {
        try {
            const qaTicketData = await QATicketApiService.GetByUser(userId);

            const qaTicketDataArray = Array.isArray(qaTicketData.data) ? qaTicketData.data : [qaTicketData.data];

            const qaTicketDataMap = qaTicketDataArray.map((item) => ({
                Title: item.Title || item.title,
                Description: item.Description || item.description,
                Apporweb: item.Apporweb || item.apporweb,
                Status: item.Status || item.status,
                CreatedOn: new Date(item.CreatedOn || item.createdOn).toISOString().split('T')[0],//item.createdOn || item.createdDate,
                Id: item.Id || item.id
            }));


            console.log("Combined Data:", qaTicketDataMap); // Check the structure here
            setData(qaTicketDataMap);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    const Auth = useAuth();
    const user = Auth.authState.user;

    useEffect(() => {
        if (admin) {
            fetchData();
        } else {
            fetchPublisherData(user.id);
        }

    }, []);

    const handleSearch = (e) => setSearchTerm(e.target.value);

    const openEditModal = (index) => {
        setCurrentItem(data[index]);
        setIsEditing(true);
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        try {
            const qapData = {
                Title: currentItem.Title,
                Description: currentItem.Description,
                Apporweb: currentItem.Apporweb,
                Status: currentItem.Status,
                UserId: user.id,
                Id: currentItem.Id,
            };
            await QATicketApiService.Update(qapData);

            setIsEditing(false);
            toast.success('Edit Successfull');
            fetchData(); // Refresh data after editing
        } catch (error) {
            toast.error('Error updating item:', error.message);
            console.error('Error updating item:', error);
        }
    };

    const openDeleteModal = (index) => {
        setDeleteIndex(index);
        setIsDeleteModalOpen(true);
    };

    const confirmDelete = async () => {
        const item = data[deleteIndex];
        try {

            await QATicketApiService.Delete(item.Id);

            setIsDeleteModalOpen(false);
            toast.success("Delete successFul");
            fetchData(); // Refresh data after deletion
        } catch (error) {
            toast.error("Error deleting item:", error);
            console.error("Error deleting item:", error);
        }
    };

    const handleCancelDelete = () => {
        setIsDeleteModalOpen(false);
    };

    const handleChange = (e) => {
        setCurrentItem({
            ...currentItem,
            [e.target.name]: e.target.value,
        });
    };
    const filteredData = data.filter((row) =>
        row.Title?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="overflow-y-hidden overflow-x-auto p-5">
            {/* <h1 className="text-2xl font-bold text-gray-800 mb-5">QA Details</h1> */}
            <div className="flex justify-end mb-4">
                <input
                    type="text"
                    className="border border-gray-300 px-4 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    placeholder="Search by Name"
                    value={searchTerm}
                    onChange={handleSearch}
                />
            </div>
            <table className="min-w-full bg-white border border-gray-300 shadow-md rounded-lg">
            <thead className="bg-gradient-to-r from-gray-800 to-black text-white">
                    <tr>
                        <th className="px-6 py-3 text-left text-sm font-semibold uppercase tracking-wider">Title</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold uppercase tracking-wider">Description</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold uppercase tracking-wider">Apporweb</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold uppercase tracking-wider">Status</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold uppercase tracking-wider">Created At</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold uppercase tracking-wider">Action</th>
                        {/* <th className="px-6 py-3 text-left text-sm font-semibold uppercase tracking-wider"></th> */}
                    </tr>
                </thead>
                <tbody>
                    {filteredData.map((row, index) => (
                        <tr
                            key={index}
                            className="bg-white border-b transform hover:bg-gray-100"
                        >
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{row.Title}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{row.Description}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{row.Apporweb}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{row.Status}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{row.CreatedOn}</td>
                            {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{row.Action}</td> */}
                            <td className="px-6 py-4 flex justify-start whitespace-nowrap text-sm font-medium">
                                <button onClick={() => handleView(index)}
                                    className="px-4 py-2 m-2 rounded-md text-white transition duration-200 ease-in-out 
                                        bg-yellow-500 hover:bg-yellow-600 focus:ring-green-400"
                                >
                                    View
                                </button>
                                {
                                    admin === false ?
                                        <button onClick={() => openEditModal(index)}
                                            className={`px-4 py-2 m-2 rounded-md text-white transition duration-200 ease-in-out 
                                        bg-blue-500 hover:bg-blue-600 focus:ring-blue-400`}
                                        >
                                            Edit
                                        </button>
                                        : null
                                }
                                <button onClick={() => openDeleteModal(index)}
                                    className={`px-4 py-2 m-2 rounded-md text-white transition duration-200 ease-in-out 
                                        bg-red-500 hover:bg-red-600 focus:ring-red-400`}
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Edit Modal */}
            <QATicketReplyModal
                isOpen={isRepy}
                onClose={() => setIsRepy(false)}
                ticketId={ticketId}
                initialMessages={currentTicketReplies}
            />
            {isView && (
                <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-white p-5 rounded shadow-lg w-1/2">
                        <h2 className="text-2xl font-bold mb-4">View Item</h2>
                        <label className="block mb-2">
                            Title:
                            <input
                                type="text"
                                readOnly
                                name="Title"
                                value={currentItem.Title}
                                className="w-full p-2 border border-gray-300 rounded mt-1 bg-gray-100 cursor-not-allowed"
                            />
                        </label>

                        <label className="block mb-2">
                            Description:
                            <textarea
                                name="Description"
                                readOnly
                                value={currentItem.Description}
                                className="w-full p-2 border border-gray-300 rounded mt-1 bg-gray-100 cursor-not-allowed"
                            />
                        </label>
                        <label className="block mb-2">
                            Apporweb:
                            <input
                                type="text"
                                readOnly
                                name="Apporweb"
                                value={currentItem.Apporweb}
                                className="w-full p-2 border border-gray-300 rounded mt-1 bg-gray-100 cursor-not-allowed"
                            />
                        </label>
                        <label className="block mb-2">
                            Status:
                            <input
                                readOnly
                                type="text"
                                name="Url"
                                value={currentItem.Status}
                                className="w-full p-2 border border-gray-300 rounded mt-1 bg-gray-100 cursor-not-allowed"
                            />
                        </label>
                        <div className="flex justify-end mt-4">
                            <button onClick={async () => { await handleReply(currentItem.Id) }}
                                className={`px-3 py-1 m-1 rounded-md text-white transition duration-200 ease-in-out 
                                    bg-blue-500 hover:bg-blue-600 focus:ring-blue-400`}
                            >
                                Reply Ticket
                            </button>
                            {
                                !admin && currentItem.Status != "Resolved" && (<button
                                    type="button"
                                    onClick={async () => await handleResolveTicket(currentItem.Id)}
                                    className="bg-gray-500 hover:bg-gray-600 focus:ring-gray-400 m-1 text-white px-4 py-2 rounded"
                                >
                                    Resolve Ticket
                                </button>)
                            }

                            <button
                                type="button"
                                onClick={() => setIsView(false)}
                                className="bg-gray-500 hover:bg-gray-600 focus:ring-gray-400 m-1 text-white px-4 py-2 rounded"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {isEditing && (
                <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-white p-5 rounded shadow-lg w-1/2">
                        <h2 className="text-2xl font-bold mb-4">Edit Item</h2>
                        <form onSubmit={handleEditSubmit}>

                            <label className="block mb-2">
                                Title:
                                <input
                                    type="text"
                                    name="Title"
                                    value={currentItem.Title}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-gray-300 rounded mt-1"
                                />
                            </label>

                            <label className="block mb-2">
                                Description:
                                <textarea
                                    name="Description"
                                    value={currentItem.Description}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-gray-300 rounded mt-1"
                                />
                            </label>
                            <label className="block mb-2">
                                Apporweb:
                                <input
                                    type="text"
                                    name="Apporweb"
                                    value={currentItem.Apporweb}
                                    onChange={handleChange}
                                    className="w-full p-2 border border-gray-300 rounded mt-1"
                                />
                            </label>
                            <label className="block mb-2">
                                Status:
                                <input
                                    readOnly
                                    type="text"
                                    name="Url"
                                    value={currentItem.Status}
                                    className="w-full p-2 border border-gray-300 rounded mt-1 bg-gray-100 cursor-not-allowed"
                                />
                            </label>

                            <div className="flex justify-end mt-4">
                                <button
                                    type="submit"
                                    className="bg-blue-500 hover:bg-blue-600 focus:ring-blue-400 text-white px-4 py-2 rounded mr-2"
                                >
                                    Save
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setIsEditing(false)}
                                    className="bg-gray-500 hover:bg-gray-600 focus:ring-gray-400 text-white px-4 py-2 rounded"
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Delete Confirmation Modal */}
            {isDeleteModalOpen && (
                <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-white p-5 rounded shadow-lg w-1/3">
                        <h2 className="text-2xl font-bold mb-4">Confirm Deletion</h2>
                        <p className="mb-4">Are you sure you want to delete this item?</p>
                        <div className="flex justify-end">
                            <button onClick={confirmDelete} className="bg-red-500 text-white px-4 py-2 rounded mr-2">Yes, Delete</button>
                            <button onClick={handleCancelDelete} className="bg-gray-500 text-white px-4 py-2 rounded">Cancel</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default QATicketTable;
